module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-left-circle-3824ca7a.svg";